'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'rocket-launch';
var width = 512;
var height = 512;
var aliases = [128640];
var unicode = 'e027';
var svgPathData = 'M504.1 20.9c-1.3-6.3-6.2-11.3-12.6-12.6-44.3-8.9-111.2-14.2-175.5 19-37.4 19.3-72.8 51.1-102.1 100.7l-90.4 0c-16.9 0-32.5 8.8-41.2 23.3L29.5 239.5C16.7 260.9 32 288 56.9 288l103.5 0c35.3 0 64 28.7 64 64l0 103.5c0 24.9 27.1 40.2 48.5 27.4L361.1 430c14.5-8.7 23.3-24.3 23.3-41.2l0-90.4c49.6-29.3 81.4-64.7 100.7-102.1 33.2-64.3 27.8-131.2 19-175.5zM352.4 315.3l0 73.5c0 5.6-2.9 10.8-7.8 13.7l-88.2 52.9 0-103.5c0-1.1 0-2.3-.1-3.4 36.8-9.2 68.6-20.5 96.1-33.3zm-102.5 1.9c-9.7-25.1-29.7-45-54.8-54.8 30.6-121.4 83.2-179.7 135.6-206.8 50.4-26 103.6-24.7 143.9-18 6.8 40.3 8 93.5-18 143.9-27.1 52.4-85.4 105-206.8 135.6zm-86.1-61.2c-1.1 0-2.2-.1-3.4-.1l-103.5 0 52.9-88.2c2.9-4.8 8.1-7.8 13.7-7.8l73.5 0c-12.9 27.4-24.1 59.3-33.3 96.1zM368.4 168a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-56-24a56 56 0 1 0 112 0 56 56 0 1 0 -112 0zM130.2 450.9c-9.5 9.5-25.8 17.1-46.8 22.1-17.5 4.2-35.7 6-50.6 6.6 .7-14.9 2.5-33.1 6.6-50.6 5-21 12.5-37.3 22.1-46.8 19-19 49.7-19 68.7 0s19 49.7 0 68.7zm22.6 22.6c31.5-31.5 31.5-82.5 0-114s-82.5-31.5-114 0c-31.3 31.3-37.5 92-38.3 126.4-.4 14.6 11.2 26.2 25.9 25.9 34.5-.8 95.1-7 126.4-38.3z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRocketLaunch = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;